<div #chartContainer class="w-100 h-100 notranslate d-flex flex-column overflow-hidden">
    <div echarts
         [options]="options"
         (chartInit)="onChartInit($event)"
         (chartClick)="onChartClick($event)"
         class="w-100 h-100">
    </div>
</div>
